import { getTimeZone } from './helperFunctions';
import type { Kitchen } from '../types';

const MS_PER_DAY = 86_400_000;
const DEFAULT_RANGE_DAYS = 7;

/** The parts of a moment as written in the kitchen's zone, 24-hour, ASCII digits. */
export const partsInKitchen = (at: Date | string, kitchen: Kitchen): Record<string, string> =>
  Object.fromEntries(
    new Intl.DateTimeFormat('en-GB', {
      timeZone: getTimeZone(kitchen),
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hourCycle: 'h23'
    })
      .formatToParts(new Date(at))
      .map(({ type, value }) => [type, value])
  );

/** `yyyy-MM-dd`: the kitchen's calendar day at `at`. */
export const dayInKitchen = (at: Date, kitchen: Kitchen): string => {
  const p = partsInKitchen(at, kitchen);
  return `${p.year}-${p.month}-${p.day}`;
};

/** `yyyy-MM-dd` moved by whole days, computed on the string in UTC, never through a local-zone `Date`. */
export const shiftDay = (day: string, days: number): string =>
  new Date(Date.parse(`${day}T00:00:00Z`) + days * MS_PER_DAY).toISOString().slice(0, 10);

/** What the Batch Tracking page lists until a range is picked: the sidebar day and the seven days before it. */
export const defaultBatchRange = (date: string): { from: string; to: string } => ({
  from: shiftDay(date, -DEFAULT_RANGE_DAYS),
  to: date
});
